import { createSlice } from "@reduxjs/toolkit";

const sliceName = "filter";

const initialState = {
    value: "All"
};

const filterSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        filteredBy: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { filteredBy } = filterSlice.actions;

export default filterSlice.reducer;